import { type HUImageDto, convertImageFromDto } from "@modules/dtos/imageDto"
import { type Subscriber } from "@modules/profile/subscriber/subscriberTypes"

// TODO refactor to SlotSubscriberDto
export type SubscriberDto = {
  memberId: string
  userId: string
  firstname: string
  lastname: string
  username: string
  avatar: HUImageDto | null
  absent: boolean
  isBirthday: boolean
  isTrial: boolean
  isDropIn: boolean
  internalNote: string | null
}

export function convertSubscriberFromDto(dto: SubscriberDto): Subscriber {
  return {
    id: dto.userId,
    memberId: dto.memberId,
    firstname: dto.firstname,
    lastname: dto.lastname,
    username: dto.username,
    avatar: dto.avatar ? convertImageFromDto(dto.avatar) : undefined,
    absent: dto.absent,
    isBirthday: dto.isBirthday,
    isTrial: dto.isTrial,
    isDropIn: dto.isDropIn,
    internalNote: dto.internalNote,
  }
}

export enum SlotParticipantStatus {
  REGISTERED = "REGISTERED",
  PENDING = "PENDING",
}
